import { ActionContext } from 'vuex'
import apiAdminUmbType from '@/api/admin/umbType'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IUmbTypeState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbUmbType } from '@/models/alodb/AloDbUmbType';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class UmbTypeAction {
   
  public [types.UMBTYPE_REQUEST](context: ActionContext<IUmbTypeState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.UMBTYPE_REQUEST)
        apiAdminUmbType
          .getUmbTypes()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const umbTypeArray = resp.data.data as AloBaseArray<AloDbUmbType>
              context.commit(types.UMBTYPE_SUCCESS, umbTypeArray.items)
              resolve(umbTypeArray.items)
            } else {
              context.commit(types.UMBTYPE_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.UMBTYPE_ERROR)
            reject()
          })
      })
  }

  public [types.UMBTYPE_ENSURE_LIST](context: ActionContext<IUmbTypeState, IRootState>) {
    if(context.state.umbTypes.length == 0) {
        return context.dispatch(types.UMBTYPE_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.umbTypes)            
        })
    }    
  }

  public [types.UMBTYPE_SELECT_DETAIL](context: ActionContext<IUmbTypeState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const umbType = context.getters.umbTypesById[itemId] as AloDbUmbType      
      if(umbType) {        
        if(umbType.detailLoaded) {
          context.commit(types.UMBTYPE_SELECT_DETAIL,umbType)
          resolve(umbType)
        }
        else{
          context.dispatch(types.UMBTYPE_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.UMBTYPE_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newUmbType = new AloDbUmbType()
        context.commit(types.UMBTYPE_SELECT_DETAIL,newUmbType)
        resolve(newUmbType)
      }
    })
  }

  public [types.UMBTYPE_SELECT_DETAIL_REQUEST](context: ActionContext<IUmbTypeState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.UMBTYPE_SELECT_DETAIL_REQUEST, itemId)
        apiAdminUmbType
          .getUmbType(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const umbType = resp.data.data as AloDbUmbType
              context.commit(types.UMBTYPE_SELECT_DETAIL_SUCCESS, umbType)
              context.commit(types.UMBTYPE_SELECT_DETAIL,umbType)
              resolve(umbType)
            } else {
              context.commit(types.UMBTYPE_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.UMBTYPE_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.UMBTYPE_SAVE_REQUEST](context: ActionContext<IUmbTypeState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmUmbType.id
        context.commit(types.UMBTYPE_SAVE_REQUEST,context.state.modifiedAdmUmbType.UMT_LIBELLE)
        apiAdminUmbType
          .saveUmbType(context.state.modifiedAdmUmbType)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const umbType = resp.data.data as AloDbUmbType            
              context.commit(types.UMBTYPE_SELECT_DETAIL_SUCCESS, umbType)
              context.commit(types.UMBTYPE_SELECT_DETAIL,umbType)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:umbType.UMT_LIBELLE}))               
              if(tryRedirect && router.app.$route.name === 'NewUmbType') router.push({name:'EditUmbType',params:{umbTypeid:umbType.id!.toString()}})
              resolve(umbType)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.UMBTYPE_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.UMBTYPE_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))              
              console.error(er)
              reject(er)
            }   
            else{                       
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.UMBTYPE_UPDATE_MODIFIED_ADM](context: ActionContext<IUmbTypeState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UMBTYPE_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmUmbType)
    })
  }
  
  public [types.UMBTYPE_CANCEL_MODIFIED_ADM](context: ActionContext<IUmbTypeState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UMBTYPE_SELECT_DETAIL,context.state.originalAdmUmbType)
      resolve(context.state.modifiedAdmUmbType)
    })
  }

  public [types.UMBTYPE_UPDATE_FILTER_ADM](context: ActionContext<IUmbTypeState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UMBTYPE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
  
  
}

export default util.classToObject(UmbTypeAction)